import type { ByValueFilter } from '@openx/components-table/serverSideCriteriaProcessing.ts';
import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import { parseMultiValueFilter } from '@openx/utils/lib/multiValueFilter.ts';

const PHRASE_FIELDS = ['name', 'exchange_deal_id', 'exchange_id'];

export type DealLandingQueryCriteria = AllTableCriteria & {
  filters: Record<string, unknown> & {
    byPhrase: { fields: string[]; phrase: string };
    byValue: ByValueFilter;
  };
};

export const buildDealLandingQueryCriteria = (criteria: AllTableCriteria): DealLandingQueryCriteria => {
  const filters = (criteria.filters ?? {}) as Partial<Record<string, string | null>>;
  const phrase = filters.phrase ?? '';
  const byValue: ByValueFilter = [];

  for (const [key, value] of Object.entries(filters)) {
    if (key === 'phrase' || typeof value !== 'string' || value === '') {
      continue;
    }

    byValue.push({
      field: key,
      values: [value],
    });
  }

  return {
    ...criteria,
    filters: {
      ...criteria.filters,
      byPhrase: {
        fields: PHRASE_FIELDS,
        phrase: phrase.trim(),
      },
      byValue,
    },
  };
};

export const resolveDealLandingAccountFilter = (
  criteria: DealLandingQueryCriteria,
  accountTranslation?: Map<string, string>
): DealLandingQueryCriteria => {
  const { byValue } = criteria.filters;

  if (!byValue.some(filter => filter.field === 'account') || !accountTranslation) {
    return criteria;
  }

  return {
    ...criteria,
    filters: {
      ...criteria.filters,
      byValue: byValue.map(filter => {
        if (filter.field !== 'account') {
          return filter;
        }

        const values = filter.values.flatMap(value =>
          typeof value === 'string' ? parseMultiValueFilter(value) : value == null ? [] : [String(value)]
        );

        return {
          ...filter,
          values: values.map(value => accountTranslation.get(String(value)) ?? value),
        };
      }),
    },
  };
};
